<template>
    <div ref="container">
      <!-- <a-modal
        :title="title"
        :width="1600"
        :visible="visible"
        :getContainer="() => $refs.container"
        :maskStyle="{'top':'93px','left':'154px'}"
        :wrapClassName="wrapClassNameInfo()"
        :mask="isDesktop()"
        :maskClosable="false"
        @cancel="handleCancel"
        cancelText="关闭"
        style="top:50px;height: 90%;"> -->
      <div v-show="visible">
        <div style="margin-bottom:10px">
          <a-button type="primary" @click="returnList">返回</a-button>
        </div>
      
        <template slot="footer">
          <a-button @click="handleCancel">关闭</a-button>
        </template>
        <!-- 产品信息 -->
        <a-card style="margin:0px 0 20px; ">
            <span class="title">产品PI信息</span>
            <a-form-model ref="form" :model="form" >
                <a-row class="form-row" :gutter="24">
                    <a-col :span="24/3">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
                            <span>{{ productInfo.productName }}</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24/3">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品规格">
                            <span>{{ productInfo.specificationModel }}</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24/3">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="器械类型">
                            <span v-if="productInfo.deviceCategory == 1">器械</span>
                            <span v-else-if="productInfo.deviceCategory == 2">体外诊断试剂</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24/3">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码">
                            <span>{{ productInfo.categoryCode }}</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24/3">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="码制">
                            <span v-if="productInfo.codeSystem == 1">MA</span>
                            <span v-else-if="productInfo.codeSystem == 2">GS1</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
        <!-- table区域-begin -->
        <a-table
            bordered
            ref="table"
            size="middle"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :scroll="{ x: true }"
            :rowKey="(record,index)=>{return index}"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px'}"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="getInfoDetail(record)">生码</a>
              <a-divider type="vertical" />
              <a @click="manageInfo(record)">管理</a>
              <!-- <a-divider type="vertical" />
              <a @click="handleDelete(record)">隐藏</a> -->
            </span>
            <template slot="specCodeSystem" slot-scope="specCodeSystem">
                <span v-if="specCodeSystem === '1'">MA(IDcode)</span>
                <span v-else-if="specCodeSystem === '2'">GS1</span>
                <span v-else-if="specCodeSystem === ''">MA(IDcode)</span>
            </template>
            <template slot="productDiMin" slot-scope="text">
              <span v-if="text">{{ text }}</span>
              <span v-else>--</span>
            </template>
        </a-table>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <bill-detail ref="billDetail"></bill-detail>
        <!-- 生码 -->
        <PIModel ref="modalDetail" :productInfo="productInfo"  @ok="modalDetailOk" @close="modalFormClose" ></PIModel>
        
      <!-- </a-modal> -->
      </div>
      <a-row :gutter="24" v-show="!visible">
        <a-col :md="24">
          <a-card :style="cardStyle1" :bordered="false">
            <!-- 管理 -->
            <ManageModel ref="modalManage" :productInfo="productInfo" @ok="modalFormOk" @close="modalManageClose" @returnDetail="returnDetail" ></ManageModel>
            </a-card>
        </a-col>
      </a-row>
      
    </div>
  </template>
  
  <script>
    import PIModel from './PIModel'
    import ManageModel from './ManageModel'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {mixinDevice} from '@/utils/mixin'
    import { getPIInfoDetail, productPidel } from '@/api/api'
    import Vue from 'vue'
    export default {
      name: 'PIInfo',
      mixins:[JeecgListMixin, mixinDevice],
      components: {
        PIModel,
        ManageModel
      },
      data () {
        return {
          title: "PI明细",
          visible: false,
          disableMixinCreated: true,
          organLabel: '',
          supplierList: [],
          queryParam: {
            organId: "",
            number: "",
            materialParam: "",
            type: "",
            subType: "",
            status: ""
          },
          labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
          // 表头
          columns: [
            { title: '包装等级', dataIndex: 'packageLevel',width:120, ellipsis:true},
            { title: 'DI编号', dataIndex: 'productDi',width:150, },
            { title: '子级编号', dataIndex: 'productDiMin',width:150, scopedSlots: { customRender: 'productDiMin' }},
            { title: '最后生码时间', dataIndex: 'createTime',width:145},
            { title: '生码数量', dataIndex: 'codeNum',width:70},
            { title: '操作', dataIndex: 'action', width: 100, align: 'center', width: 120, scopedSlots: { customRender: 'action' },}
          ],
          dataSource:[],
          productInfo: {},
          packageLevel: null,
          url: {
            list: ""
          }
        }
      },
      created() {
      },
      methods: {
        show(record) {
            this.visible = true
            this.productInfo = record
            this.packageLevel = record.packageLevel
            console.log(record,'传过来的值=================')
            this.getPIInfoDetail(record)
        },
        async getPIInfoDetail(record){
            const params = {
                productId:this.productInfo.productId,
                codeSystem:this.productInfo.codeSystem
            }
            const res = await getPIInfoDetail(params)
            if(res.code === 200 && res.success == true ){
                console.log('获取的PI列表===========', res.result)
                this.dataSource = res.result
            }
        },
        // 生码
        getInfoDetail(record){
            this.$refs.modalDetail.add(record, this.packageLevel)
        },
        // 管理
        manageInfo(record){
            this.$refs.modalManage.show(record)
            this.visible = false
        },
        // 删除
        handleDelete(record){
            this.$confirm('是否删除数据', '确认操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.handleDeletePI(record)
            }).catch(() => {});
        },
        async handleDeletePI(record){
            const res = await productPidel({piId: record.id})
            if( res.code === 200 && res.success === true ){
                this.$message({
                type: 'success',
                message: '删除成功'
                })
                this.getPIInfoDetail()
            } else {
                this.$message({
                type: 'error',
                message: res.message
                })
            }
        },
        modalDetailOk(){
          this.getPIInfoDetail()
        },
        modalManageClose(){
          this.getPIInfoDetail()
        },
        close () {
          this.$emit('close');
          this.visible = false;
        },
        handleCancel () {
          this.close()
        },
        returnList(){
          this.close()
          // 刷新页面
          this.$emit('refresh-parent');
        },
        returnDetail(){
          this.visible = true
          this.getPIInfoDetail()
        }
      }
    }
  </script>
  
  <style scoped>
    .title {
        color: #1890FF
    }
  </style>